/* Back-in-stock modal handler — collection pages */
(function () {
  var overlay    = document.getElementById('bis-modal-overlay');
  if (!overlay) return;
  var closeBtn   = document.getElementById('bis-modal-close');
  var titleEl    = document.getElementById('bis-modal-title');
  var formArea   = document.getElementById('bis-form-area');
  var emailInput = document.getElementById('bis-email-input');
  var errorEl    = document.getElementById('bis-error-msg');
  var submitBtn  = document.getElementById('bis-submit-btn');
  var successEl  = document.getElementById('bis-success-msg');
  var currentVariantId = null;

  function openModal(variantId, productTitle) {
    currentVariantId = variantId;
    titleEl.textContent  = productTitle || 'Notify Me When Available';
    overlay.style.display = 'flex';
    overlay.setAttribute('aria-hidden', 'false');
    emailInput.value     = '';
    errorEl.style.display   = 'none';
    successEl.style.display = 'none';
    formArea.style.display  = 'block';
    submitBtn.disabled    = false;
    submitBtn.textContent = 'Notify me when available';
    setTimeout(function () { emailInput.focus(); }, 50);
  }

  function closeModal() {
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
    currentVariantId = null;
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') closeModal();
  });

  submitBtn.addEventListener('click', function () {
    var email = emailInput.value.trim();
    if (!email || !email.includes('@')) {
      errorEl.textContent   = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      return;
    }
    if (!currentVariantId) return;

    submitBtn.disabled    = true;
    submitBtn.textContent = 'Subscribing…';
    errorEl.style.display = 'none';

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UTkMAa', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariantId } }
          }
        }
      })
    })
    .then(function (res) {
      if (res.ok) {
        formArea.style.display  = 'none';
        successEl.textContent   = "You’re in! We’ll let you know when it’s back.";
        successEl.style.display = 'block';
      } else {
        return res.json().then(function (data) {
          throw new Error((data.errors && data.errors[0] && data.errors[0].detail) || 'Something went wrong. Please try again.');
        });
      }
    })
    .catch(function (err) {
      errorEl.textContent   = err.message;
      errorEl.style.display = 'block';
      submitBtn.disabled    = false;
      submitBtn.textContent = 'Notify me when available';
    });
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.klaviyo-bis-trigger');
    if (!trigger) return;
    if (window.Shopify && window.Shopify.template === 'product') return;
    e.stopPropagation();
    openModal(trigger.dataset.variantId, trigger.dataset.productTitle);
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id') {
      window.klaviyo_variant = { id: 'shopify::variant:' + e.target.value };
    }
  });
})();

/* Back-in-stock inline form handler — product pages */
(function () {
  function submitBisForm(form) {
    var emailInput = form.querySelector('.bis-inline-form__email');
    var msgEl      = form.querySelector('.bis-inline-form__msg');
    var row        = form.querySelector('.bis-inline-form__row');
    var btn        = form.querySelector('.bis-inline-form__btn');

    var email = emailInput.value.trim();
    if (!email || !email.includes('@')) {
      msgEl.textContent = 'Please enter a valid email address.';
      msgEl.className   = 'bis-inline-form__msg bis-inline-form__msg--error';
      msgEl.hidden      = false;
      return;
    }

    var variantInput = form.closest('product-form-component')
      ? form.closest('product-form-component').querySelector('[name="id"]')
      : document.querySelector('product-form-component [name="id"]');
    var variantId = (variantInput && variantInput.value) || form.dataset.variantId;
    if (!variantId) return;

    btn.disabled    = true;
    btn.textContent = 'Subscribing…';
    msgEl.hidden    = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UTkMAa', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-10-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    })
    .then(function (res) {
      if (res.ok) {
        row.style.display = 'none';
        msgEl.textContent = "You’re in! We’ll let you know when it’s back.";
        msgEl.className   = 'bis-inline-form__msg bis-inline-form__msg--success';
        msgEl.hidden      = false;
      } else {
        return res.json().then(function (data) {
          throw new Error((data.errors && data.errors[0] && data.errors[0].detail) || 'Something went wrong. Please try again.');
        });
      }
    })
    .catch(function (err) {
      msgEl.textContent = err.message;
      msgEl.className   = 'bis-inline-form__msg bis-inline-form__msg--error';
      msgEl.hidden      = false;
      btn.disabled      = false;
      btn.textContent   = 'Notify Me';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bis-inline-form__btn');
    if (!btn) return;
    var form = btn.closest('.bis-inline-form');
    if (form) submitBisForm(form);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('.bis-inline-form__email');
    if (!input) return;
    var form = input.closest('.bis-inline-form');
    if (form) submitBisForm(form);
  });
})();
